import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../../../Constants";
import { useParams } from "react-router-dom";
import NavHeightAdjust from "../../../../../components/navbar/NavHeightAdjust";

const AccountCollections = () => {
  const { buildingID } = useParams(); // Capture buildingID from the route params
  const [accountData, setAccountData] = useState({});
  const [callResults, setCallResults] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);

  useEffect(() => {
    const fetchAccountCollections = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/account-collections/${buildingID}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include", // Ensure cookies are included for session management
          }
        );

        if (response.ok) {
          const data = await response.json();
          setAccountData(data);
          setCallResults(data.callResults || []); // Assuming this structure
          setInvoiceData(data.invoices || []); // Assuming this structure
        } else {
          console.error(
            "Failed to fetch account collections:",
            response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching account collections:", error);
      }
    };

    if (buildingID) {
      fetchAccountCollections();
    }
  }, [buildingID]);

  return (
    <NavHeightAdjust>
      <div className="w-full p-6 bg-white rounded-xl shadow-lg">
        {/* Top section for Call Number, Building Site, Contact, etc. */}
        <div className="mb-4 flex flex-wrap gap-4">
          <div className="flex-1">
            <label>Call Number</label>
            <input
              type="text"
              value={accountData.callNumber || ""}
              className="border w-full p-2"
              readOnly
            />
          </div>
          <div className="flex-1">
            <label>Building Site</label>
            <input
              type="text"
              value={accountData.buildingSite || ""}
              className="border w-full p-2"
              readOnly
            />
          </div>
          <div className="flex-1">
            <label>Contact</label>
            <input
              type="text"
              value={accountData.contact || ""}
              className="border w-full p-2"
              readOnly
            />
          </div>
          <div className="flex-1">
            <label>Phone Number</label>
            <input
              type="text"
              value={accountData.phoneNumber || ""}
              className="border w-full p-2"
              readOnly
            />
          </div>
          <div className="flex-1">
            <label>Email Address</label>
            <input
              type="text"
              value={accountData.email || ""}
              className="border w-full p-2"
              readOnly
            />
          </div>
          <div className="flex-1">
            <label>Date</label>
            <input
              type="date"
              value={accountData.date || ""}
              className="border w-full p-2"
              readOnly
            />
          </div>
        </div>

        {/* Call Results Section */}
        <div className="mb-4">
          <strong>Call Results:</strong>
          <div className="border mt-2 rounded-lg p-2 bg-gray-100">
            {callResults.length > 0 ? (
              callResults.map((call, index) => (
                <div key={index} className="p-1 border-b">
                  {call.date} - {call.description}
                </div>
              ))
            ) : (
              <p>No call results available.</p>
            )}
          </div>
        </div>

        {/* Service / Maintenance / Repair checkboxes */}
        <div className="mb-4">
          <label>
            <input
              type="checkbox"
              checked={accountData.service || false}
              readOnly
            />
            Service
          </label>
          <label className="ml-4">
            <input
              type="checkbox"
              checked={accountData.maintenance || false}
              readOnly
            />
            Maintenance
          </label>
          <label className="ml-4">
            <input
              type="checkbox"
              checked={accountData.repair || false}
              readOnly
            />
            Repair
          </label>
          <label className="ml-4">
            <input
              type="checkbox"
              checked={accountData.modConstruction || false}
              readOnly
            />
            Mod / Construction
          </label>
          <label className="ml-4">
            <input
              type="checkbox"
              checked={accountData.inspection || false}
              readOnly
            />
            Inspection
          </label>
        </div>

        {/* Invoice Table */}
        <table className="w-full bg-white rounded-lg overflow-hidden ring-1 ring-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 border">Invoice Number / Description</th>
              <th className="px-4 py-2 border">Proposal #</th>
              <th className="px-4 py-2 border">Current</th>
              <th className="px-4 py-2 border">30 - 60 Days</th>
              <th className="px-4 py-2 border">60 - 90 Days</th>
              <th className="px-4 py-2 border">90 - 120 Days</th>
              <th className="px-4 py-2 border">Over 120 Days</th>
            </tr>
          </thead>
          <tbody>
            {invoiceData.length > 0 ? (
              invoiceData.map((invoice, index) => (
                <tr key={index}>
                  <td className="px-4 py-2 border">
                    {invoice.invoiceNumber || "N/A"} -{" "}
                    {invoice.description || "N/A"}
                  </td>
                  <td className="px-4 py-2 border">
                    {invoice.proposalNumber || "N/A"}
                  </td>
                  <td className="px-4 py-2 border">
                    {invoice.current || "$0.00"}
                  </td>
                  <td className="px-4 py-2 border">
                    {invoice.days30_60 || "$0.00"}
                  </td>
                  <td className="px-4 py-2 border">
                    {invoice.days60_90 || "$0.00"}
                  </td>
                  <td className="px-4 py-2 border">
                    {invoice.days90_120 || "$0.00"}
                  </td>
                  <td className="px-4 py-2 border">
                    {invoice.over120 || "$0.00"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No invoices available
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Total Outstanding */}
        <div className="mt-4 flex justify-end">
          <strong>
            Total Outstanding: ${accountData.totalOutstanding || "0.00"}
          </strong>
        </div>
      </div>
    </NavHeightAdjust>
  );
};

export default AccountCollections;
